
import Bank from "../../../assets/filled/Bank.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function BankIcon({ className, dataTestid = "BankIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Bank data-testid={dataTestid} className={classes} {...rest} />
  );
}
